import { Buffer } from 'buffer'

export const fromBase64 = (base64?: string) => {
  return base64 ? Buffer.from(base64, 'base64').toString('utf-8') : undefined
}
